import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss']
})
export class TabBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
